export default [
  {
    component: () => import("pages/MediaReleaseUnsubscribedRecipients.vue"),
    path: "/media-release-unsubscribed-recipients",
  },
];
